<template>
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
      <div class="card bcard mb-4">
        <div class="card-body px-4 px-lg-5">
          <div class="text-center">
            <h2 class="text-dark-m2">
              イベント情報送信
            </h2>
            <br>
            <h6 class="text-secondary-d2">
              ステップ３．確認と送信
            </h6>
          </div>

          <div class="text-center">
            <img class="w-50" :src="img.url" />
          </div>


          <form class="mt-lg-3" autocomplete="off">
            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label class="mb-0">
                  労働組合名
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.union }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3 text-sm-right pr-0">
                <label class="mb-0">
                  氏名
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.username }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label class="mb-0">
                  事業所名
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.company }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label class="mb-0">
                  郵便番号
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.zipcode }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label class="mb-0">
                  事業所住所
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.address }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label  class="mb-0">
                  事業所電話番号
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.telno }}</span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-3  text-sm-right pr-0">
                <label class="mb-0">
                  クイズの回答
                </label>
              </div>
              <div class="col-sm-9">
                <span class=" col-sm-8 col-md-6">{{ req.price }}</span>
              </div>
            </div>

            <div class="mt-5 border-t-1 brc-secondary-l2 py-35 mx-n25">
              <div class="col-12 text-nowrap d-flex justify-content-between">
                <button @click="back" class="btn btn-outline-lightgrey btn-bold px-4" type="reset">
                  <i class="fa fa-arrow-left mr-1"></i>
                  戻る
                </button>

                <button @click="send"  class="btn btn-info btn-bold ml-2 px-4" type="button">
                  送信
                  <i class="fa fa-paper-plane ml-1"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { API, Storage} from 'aws-amplify';

export default {
  name: 'Save',
  data(){
    return {
    }
  },
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      'req',
      'img'
    ])
  },
  methods: {
    uuid(){
      var d = Date.now();
      if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
    back(){
      this.$router.back()
    },
    doSave(result){
      this.$store.commit("save",this.req)

      const paper = this.req;
      paper.imgfile = result.key

      API.post("apiReceiptPaper","/receiptpaper",{
        body: paper,
      }).then((rs) => {
        this.$loading.hide();

        // this.$alert({
        //   title: '完了',
        //   content: '送信が完了しました。',
        //   icon: 'success'
        // }).then(() => {
        //   this.$router.replace({ name: 'Home' })
        // });
        this.$alert({
          imageUrl:window.location.origin + '/bingo.jpg',
          html: '<a href="https://uachiba.com/bingo/">https://uachiba.com/bingo/</a><br>',
          confirmButtonText: `ビンゴ大会は確認しない`,
        }).then(() => {
          this.$router.replace({ name: 'Home' })
        });

      });
    },
    send() {
      this.$loading.open();

      const fileName = [
        this.uuid(),
        '.',
        this.img.file.name.split(".").slice(-1)
      ].join("");

      Storage.put(fileName, this.img.file)
        .then (result => {
          this.doSave(result)
        }).catch((err) => {
          console.log('Save Error',err)
        });

      // this.$router.push({ name: 'Save' })
      // const { name, description } = this;
      // if (!name || !description) return;

    }
  }
};
</script>
